import React, { useRef } from "react";
import { CiSearch } from "react-icons/ci";
import { IoIosClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";

const SideNav = ({ toggleMenu }) => {
  const searchTermRef = useRef();
  const navigate = useNavigate();

  const handleSearch = () => {
    toggleMenu();
    if (searchTermRef.current.value && searchTermRef.current.value.trim()) {
      const search = searchTermRef.current.value.trim();
      searchTermRef.current.value = "";
      navigate(`/recipes?q=${encodeURIComponent(search)}`);
    }
  };
  return (
    <div className="w-3/5 min-h-[100dvh] fixed z-20 right-0 top-0 bg-white">
      <IoIosClose
        size={30}
        onClick={toggleMenu}
        className="absolute right-2 top-2"
      />
      <ul className="flex flex-col gap-5 space-x-5 mt-16 items-start">
        <div className="flex items-center ml-3">
          <input
            type="text"
            className="appearance-none bg-transparent border-none w-3/4 text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
            placeholder={"Search..."}
            ref={searchTermRef}
          />
          <CiSearch className="cursor-pointer" onClick={handleSearch} />
        </div>
        <Link to="/" onClick={toggleMenu}>
          <li>Home</li>
        </Link>
        <Link to="/recipes" onClick={toggleMenu}>
          <li>Recipes</li>
        </Link>
      </ul>
    </div>
  );
};

export default SideNav;
